.ClearBoth {
    clear: both;
    height: 0px;
}

.HiddenPanel {
    display: none;
}

:host {
  display: block;
}

:host div#SocialViewStage {
    margin: 0px 12px 12px 12px;
}

:host div#SocialShareInstructions {
    padding-top: 12px;
}

:host #SocialShareLink {
    margin-top: 20px;
    margin-bottom: 20px;
}

:host #SocialShareLink textarea {
    padding-top: 12px;
    padding-bottom: 8px;
    min-height: 80px;
    font-size: 0.8em;
}

:host div#SocialShareBtn {
    margin-top: 10px;
}
